import React from 'react';
import PropTypes from 'prop-types';
import TranslationContainer from '../../../../translation/translation_container';
import Select from '../../../../form/floating_label/select';
import { getDefaultValueForFilter } from '../../../../../helper/filters/get_default_value_for_filter';

function LightboxFilterSelect(props) {
    return (
        <div className="lightbox-filter-section__filter">
            <TranslationContainer
                targetProperties={{
                    label: { translationKey: props.labelTranslationKey },
                    provideAllTranslationKey: { translationKey: props.provideAllTranslationKey },
                }}
            >
                <Select
                    name={props.name}
                    label="will-be-replaced"
                    value={props.value}
                    hasValue={getDefaultValueForFilter(props.name) !== props.value}
                    options={props.options}
                    onChange={props.onChange}
                    provideAllOption={true}
                    disabled={props.disabled}
                    highlight={props.highlight}
                    loading={props.loading}
                    unavailableOptions={props.unavailableOptions}
                />
            </TranslationContainer>
        </div>
    );
}

LightboxFilterSelect.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    options: PropTypes.array.isRequired,
    labelTranslationKey: PropTypes.string.isRequired,
    provideAllTranslationKey: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    provideAllOption: PropTypes.bool.isRequired,
    unavailableOptions: PropTypes.array,
    disabled: PropTypes.bool,
    highlight: PropTypes.bool,
    loading: PropTypes.bool,
};

LightboxFilterSelect.defaultProps = {
    disabled: false,
    highlight: false,
    loading: false,
};

export { LightboxFilterSelect };
